import React from 'react';
// import { calculateTwoDates } from '../../../assets/constants/strings';
import Sad from '../../../assets/images/sad.svg';
import Happy from '../../../assets/images/happy.svg';
import { FaTimes } from 'react-icons/fa';
import $ from 'jquery';
import './style.scoped.scss';
import config from '../../../config';

const CancelSubscription = ({ handleConfirm, isReactivate }) => {
  return (
    <div
      className='modal'
      id='cancelModal'
      role='dialog'
      aria-hidden='true'
      data-backdrop='static'
      data-keyboard='false'
    >
      <div
        className='modal-dialog modal-dialog-centered modal-lg'
        role='document'
      >
        <div className='modal-content expiry cancel'>
          <div
            className='svg-close'
            onClick={() => $('#cancelModal').modal('hide')}
          >
            <FaTimes />
          </div>

          <div className='modal-body cancelModal'>
            <img src={isReactivate ? Happy : Sad} alt='Subscription' />

            <h4 className='sad'>We're sad to see you go!</h4>

            <b>
              You will lose all benefits of your subscription and will
              immediatelly be downgraded to a Free subscription. Are you sure
              you want to cancel your subscription?
            </b>

            <div className='buttons-row'>
              {isReactivate ? (
                <React.Fragment>
                  <button
                    type='button'
                    onClick={() => $('#cancelModal').modal('hide')}
                    className='my-account-btn secondary'
                  >
                    Cancel
                  </button>
                  <button
                    type='button'
                    className='my-account-btn'
                    onClick={handleConfirm}
                  >
                    Confirm
                  </button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <button
                    type='button'
                    onClick={handleConfirm}
                    className='my-account-btn secondary'
                  >
                    Cancel Subscription
                  </button>
                  <button
                    type='button'
                    className='my-account-btn'
                    onClick={() => $('#cancelModal').modal('hide')}
                  >
                    Keep Subscription
                  </button>
                </React.Fragment>
              )}
            </div>
            <span>
              or{' '}
              <a
                className='ml-1'
                href={`${config.WordPressURL}help/`}
                target='_blank'
                rel='noreferrer'
              >
                contact us
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscription;
